'use strict';

const selectedValueExistsInOptionTraits = (targetTrait, optionsTraits = []) =>
  optionsTraits.find(
    currentOptionTrait =>
      currentOptionTrait.name === targetTrait.name &&
      currentOptionTrait.value === targetTrait.value
  );

// make sure to only pass selectedTraits with a value otherwise it will not find the correct option
module.exports = (selectedTraits, options, traitOptionsMap) => {
  const selectedTraitsKeys = Object.keys(selectedTraits);
  let optionFound;
  options.forEach(option => {
    const optionHasSelectedTraits = selectedTraitsKeys.every(selectedKey =>
      selectedValueExistsInOptionTraits(
        { name: selectedKey, value: selectedTraits[selectedKey] },
        option.traits
      )
    );
    const isSoldOut = option.isSoldOut;
    const isUnavailable = option.status !== 'open';
    if (optionHasSelectedTraits && !(isSoldOut || isUnavailable)) {
      if (
        !optionFound ||
        (optionFound && optionFound.price.amount > option.price.amount)
      ) {
        optionFound = option;
      }
    }
  });
  if (optionFound) {
    return optionFound;
  }
  // If options doesn't have option.traits try to find it using traitOptionsMap
  if (selectedTraitsKeys.length === 1) {
    const keyValue = `${selectedTraitsKeys[0]}-${
      selectedTraits[selectedTraitsKeys[0]]
    }`;
    if (traitOptionsMap[keyValue] && traitOptionsMap[keyValue].length) {
      return traitOptionsMap[keyValue][0];
    }
  }
  // default return first option
  return options[0];
};
